import React from "react";

const CheckCircleBig = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4001 23.1096L25.6 11.9097L23.2877 9.6001L14.4001 18.4877L9.42201 13.6877L7.10967 16.0001L14.4001 23.1096ZM16.0001 0.000140559C19.1646 0.000140559 22.258 0.93852 24.8892 2.69661C27.5203 4.45471 29.5711 6.95356 30.7821 9.87716C31.9931 12.8008 32.3099 16.0178 31.6926 19.1215C31.0752 22.2252 29.5514 25.0761 27.3137 27.3137C25.0761 29.5514 22.2252 31.0752 19.1215 31.6926C16.0178 32.3099 12.8008 31.9931 9.87716 30.7821C6.95356 29.5711 4.45471 27.5203 2.69661 24.8892C0.93852 22.258 0.000140559 19.1646 0.000140559 16.0001C-0.00869518 13.8965 0.399124 11.8119 1.20007 9.86672C2.00101 7.92153 3.17922 6.1542 4.66671 4.66671C6.1542 3.17922 7.92153 2.00101 9.86672 1.20007C11.8119 0.399124 13.8965 -0.00869518 16.0001 0.000140559Z"
        fill="white"
      />
    </svg>
  );
};

CheckCircleBig.defaultProps = {
  width: 14,
  height: 14,
  fill: "white",
};

export default CheckCircleBig;
